class NumberFormatter
{
    defaultCurrency = 'USD';
    formatters = {};

    constructor() {
        console.debug('Creating new number formatter!');
    }

    _format(num, minFractionDigits, maxFractionDigits, currency)
    {
        const key = [minFractionDigits, maxFractionDigits, currency].join('|');

        if (!(key in this.formatters)) {
            const options = {};

            if (typeof minFractionDigits !== 'undefined') {
                options['minimumFractionDigits'] = minFractionDigits;
            }

            if (typeof maxFractionDigits !== 'undefined') {
                options['maximumFractionDigits'] = maxFractionDigits;
            }

            if (typeof currency !== 'undefined') {
                options['style'] = 'currency';
                options['currency'] = currency;
            }

            this.formatters[key] = Intl.NumberFormat('en-US', options);
        }

        return this.formatters[key].format(num);
    }

    formatAuto(num, minFractionDigits, maxFractionDigits)
    {
        return this._format(num, minFractionDigits, maxFractionDigits);
    }

    formatFixed(num, fractionDigits)
    {
        return this._format(num, fractionDigits, fractionDigits);
    }

    formatCurrencyAuto(num, currency)
    {
        if (Number.isSafeInteger(num)) {
            return this._format(num, 0, 0, currency);
        }

        return this._format(num, undefined, undefined, currency || this.defaultCurrency);
    }

    formatCurrencyFixed(num, fractionDigits, currency)
    {
        return this._format(num, fractionDigits, fractionDigits, currency || this.defaultCurrency);
    }
}

const numberFormatter = new NumberFormatter();

Number.prototype.format = function () {
    if (arguments.length === 0) {
        return numberFormatter.formatAuto(this);
    }

    if (arguments.length === 1) {
        return numberFormatter.formatFixed(this, arguments[0]);
    }

    if (arguments.length === 3 && typeof arguments[1] === 'string') {
        return this.formatLegacy(arguments[0], arguments[1], arguments[2]);
    }

    return numberFormatter.formatAuto(this, arguments[0], arguments[1]);
};

Number.prototype.formatCurrency = function () {
    if (arguments.length > 1) {
        return numberFormatter.formatCurrencyFixed(this, arguments[0], arguments[1]);
    }

    return numberFormatter.formatCurrencyAuto(this, arguments[0]);
};

Number.prototype.formatLegacy = function(decimals, dec_point, thousands_sep) {
    let number = this;

    number = (number + '')
        .replace(/[^0-9+\-Ee.]/g, '');

    let n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',

        toFixedFix = function (n, prec) {
            const k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k)
                .toFixed(prec);
        };

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
        .split('.');

    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += (new Array(prec - s[1].length + 1)).join('0');
    }

    return s.join(dec);
}
